import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const formatAmount = (value) => {
  const number = Number(value) || 0;
  return Number.isInteger(number) ? number : Number(number.toFixed(2));
};

const AllocationSummary = ({
  currentAmount = 0,
  totalAmount = 0,
  assignedRecipients = [],
  unit = 'lbs',
}) => {
  const { t } = useTranslation('translation');
  const remaining = totalAmount - currentAmount;
  const isOver = remaining < 0;

  const reservedAmount = assignedRecipients
    .filter(
      (recipient) => recipient.teamId && recipient.teamId !== 'unassigned'
    )
    .reduce(
      (acc, recipient) => acc + parseFloat(recipient.reservedWeight || 0),
      0
    );
  if (totalAmount <= 0) return null;

  return (
    <Stack spacing={0.25}>
      <Typography
        variant="subtitle2"
        sx={{
          color: isOver ? 'error.main' : 'text.primary',
          fontWeight: 600,
          transition: 'color 0.2s ease',
        }}
      >
        {t('donations.reserved-amount')}: {formatAmount(reservedAmount)} /{' '}
        {formatAmount(totalAmount)} {unit}
      </Typography>
      {isOver && (
        <Typography variant="caption" sx={{ color: 'error.main' }}>
          {t('donations.amount-over-total', {
            amount: formatAmount(Math.abs(remaining)),
            unit,
          })}
        </Typography>
      )}
    </Stack>
  );
};

export default AllocationSummary;
